/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayoutTableResponse } from './PayoutTableResponse';
import {
    PayoutTableResponseFromJSON,
    PayoutTableResponseFromJSONTyped,
    PayoutTableResponseToJSON,
    PayoutTableResponseToJSONTyped,
} from './PayoutTableResponse';

/**
 * 
 * @export
 * @interface GetPayoutTablesResponse
 */
export interface GetPayoutTablesResponse {
    /**
     * 
     * @type {Array<PayoutTableResponse>}
     * @memberof GetPayoutTablesResponse
     */
    payoutTables?: Array<PayoutTableResponse>;
}

/**
 * Check if a given object implements the GetPayoutTablesResponse interface.
 */
export function instanceOfGetPayoutTablesResponse(value: object): value is GetPayoutTablesResponse {
    return true;
}

export function GetPayoutTablesResponseFromJSON(json: any): GetPayoutTablesResponse {
    return GetPayoutTablesResponseFromJSONTyped(json, false);
}

export function GetPayoutTablesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayoutTablesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'payoutTables': json['payoutTables'] == null ? undefined : ((json['payoutTables'] as Array<any>).map(PayoutTableResponseFromJSON)),
    };
}

export function GetPayoutTablesResponseToJSON(json: any): GetPayoutTablesResponse {
    return GetPayoutTablesResponseToJSONTyped(json, false);
}

export function GetPayoutTablesResponseToJSONTyped(value?: GetPayoutTablesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payoutTables': value['payoutTables'] == null ? undefined : ((value['payoutTables'] as Array<any>).map(PayoutTableResponseToJSON)),
    };
}

